import(/* webpackMode: "eager" */ "/poc-codegiant/app/global-error.tsx")